import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiUrls } from './ApiUrls';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileResponseModel } from '../model/FileResponseModel';
import { QueryExecutorModel } from '../model/QueryExecutorModel';
import { QueryExecutorDetailModel } from '../model/QueryExecutorDetailModel';
import { Page } from '../model/Page';
import { DashboardDataEntryModel } from '../model/DashboardDataEntryModel';
import { DashboardNotifyModel } from '../model/DashboardNotifyModel';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardDataEntryService {

  constructor(private httpClient: HttpClient, private _snackBar: MatSnackBar) { }

  initReportForm() {
    return this.httpClient.get<{
      lotteryList: {[key: number]: string}, 
      reports: {[key: string]: string}, 
      status: string, 
      errorMessage: string
    }>(ApiUrls.reportInitFormUrl);
  }
  
  fetchDashboardList(page: number, size: number, filterText: string) {
    return this.httpClient.get<Page<DashboardDataEntryModel>>(ApiUrls.dashboardDataEntryList + 
      `?page=${page}&size=${size}&filterText=${filterText}`);
  }
  
  initDashboardDataEntryForm() {
    return this.httpClient.get<{
      boards: {[key: number]: string}, 
    }>(`${ApiUrls.initDashboardDataEntryFormUrl}`);
  }

  getDashboardDataEntryBykey(key: number) {
    return this.httpClient.get<DashboardNotifyModel>(`${ApiUrls.dashboardDataEntryDetail.replace('{dashboardKey}', key.toString())}`);
  }

  // submitData(formData: any): Observable<any> {
  //   const endpoint = `${ApiUrls}/secure/dashboard/submitData`;
  //   return this.httpClient.post(endpoint, formData);
  // }

  submitData(dashboardKey: number, formData: any) {
    return this.httpClient.post<{status: string, errorMessage: string}>(
      ApiUrls.dashboardSumbitData.replace('{dashboardKey}', dashboardKey.toString()),formData
    );
  }

  async successToast(msg) {
    await this._snackBar.open(
      msg,
      "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "success-toast",
        duration: 3 * 1000,
      }
    );
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
        horizontalPosition: "right",
        verticalPosition: "top",
        panelClass: "error-toast",
        duration: dur ? dur : 3 * 1000,
      }
    );
  }

  generateDashboardReport(type:string,generationDate: string) {
    let reqParams =
    `?type=${type}&generationDate=${generationDate}`;
    return   this.httpClient.get<DashboardNotifyModel>(
      ApiUrls.generateDashboardReport + reqParams
    );

  
  }
}
